import { Box, Checkbox, Icon, List, ListItem, Tooltip, Typography } from '@mui/material'
import { useState, Dispatch, SetStateAction, useMemo, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { removeAllReference } from '../../../../../utils/methods/removedReference';
import { useStyles } from '../styles';
import { icons } from '../../../../../utils/icons';
import { TabsChildren } from '../../../../logbook/pages/main/components/access/utils/enums/tabs';


const useTables = ({ setUserSelected, userSelected, dataFilter, filterRow, ...props }: {
  filterRow: ({ value, list }: {
    value: Record<string, unknown>;
    list: any[];
  }) => any[]; dataFilter: Record<string, unknown>;
  dataUsers: {
    id: number;
    division: string;
    name: string;
    curp: string;
    roleId: number;
    roleName: string;
    userType: number;
    areaId: number[];
    areaName: string;
    departmentId: number[];
    departmentName: string;
    userTypeDescription: string;
  }[];
  tab: string; userSelected: Record<string, boolean>; setUserSelected: Dispatch<SetStateAction<Record<string, boolean>>>,
}) => {
  const { t } = useTranslation()
  const styles = useStyles()
  const [openModal, setOpenModal] = useState<{
    open: boolean
    title: string
    description: string
    id: string | number
    confirm?: () => void
  }>({
    id: '',
    open: false,
    title: '',
    description: '',
  })
  const [deleteSelected, setDeletedSelected] = useState<string[]>([])
  const [userFolioSelected, setUserFolioSelected] = useState<
    Record<
      string,
      {
        seeFile?: boolean
        downloadFile?: boolean
      }
    >
  >({})

  const closeModal = () => {
    setOpenModal((prev) => ({
      ...prev,
      open: false,
      confirm: undefined
    }))
  }

  const handleSelect = ({ id, value, name }: { id: string; value: boolean; name: 'seeFile' | 'downloadFile' }) => {
    if (name == 'seeFile' && !value && !!userFolioSelected?.[id]?.downloadFile) {
      setOpenModal((prev) => ({
        ...prev,
        open: true,
        id,
        title: t('filesManager.modal.titles.deleteSettings'),
        description: t('filesManager.modal.description.deleteSettings'),
        confirm: () => {
          setUserFolioSelected((prev) => ({
            ...prev,
            [id]: {
              ...prev[id],
              [name]: value,
              downloadFile: false
            },
          }))
          closeModal()
        }
      }))
    } else {
      setUserFolioSelected((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          [name]: value,
        },
      }))
    }
  }

  const [row, setRow] = useState<
    {
      id: number | string
      name: string
      role: number | string
      roleName: number | string
      areaName: string
      departmentName: string
      userTypeDescription: string
      userType: number
      areaId: number[]
      departmentId: number[]
    }[]>([])

  const getUsersThatCanManageFolios = () => {
    let newSelectedUser: Record<
      string,
      {
        seeFile?: boolean
        downloadFile?: boolean
      }
    > = structuredClone(userFolioSelected)

    const newRow: {
      id: number | string
      name: string
      role: number | string
      roleName: number | string
      areaName: string
      departmentName: string
      userTypeDescription: string
      userType: number
      areaId: number[]
      departmentId: number[]
    }[] = []

    Object.entries(userSelected)?.forEach(([key, item]) => {
      const userExtraData = props?.dataUsers?.find((itemUsers) => itemUsers.id?.toString() == key)

      if (!!item && !!userExtraData) {

        if (!newSelectedUser[key]) {
          newSelectedUser = {
            ...newSelectedUser,
            [key]: {
              ...newSelectedUser[key],
              seeFile: false,
              downloadFile: false,
            },
          }
        } else {
          newSelectedUser = { ...newSelectedUser, [key]: newSelectedUser[key] }
        }

        newRow.push({
          id: userExtraData?.id ?? '',
          name: userExtraData?.name ?? '',
          role: userExtraData?.roleId ?? '',
          roleName: userExtraData?.roleName ?? '',
          areaName: userExtraData?.areaName ?? '',
          departmentName: userExtraData?.departmentName ?? '',
          userTypeDescription: userExtraData?.userTypeDescription ?? '',
          userType: userExtraData?.userType ?? 0,
          areaId: userExtraData.areaId,
          departmentId: userExtraData.departmentId
        })
      }
    })

    setRow(
      newRow?.sort((a) => {
        if (!!newSelectedUser?.[a.id]?.seeFile) {
          return -1
        }
        return 1
      })
    )
    setUserFolioSelected(newSelectedUser)
  }

  const setAllSettingsFolioUser = (data: {
    skip?: boolean
    filter?: Record<string, any>[]
    userFolio: Record<
      string,
      {
        seeFile?: boolean
        downloadFile?: boolean
      }
    >
  }) => {
    setUserFolioSelected(data.userFolio)
  }

  const rowFiltered = useMemo(() => filterRow({ list: row, value: dataFilter }), [row, dataFilter])

  const headersChecks = useMemo(() => {
    const userFolioSelectedCopy = removeAllReference(userFolioSelected)
    const seeFile = rowFiltered.some(item => !userFolioSelectedCopy?.[item.id]?.seeFile)
    const downloadFile = rowFiltered.some(item => !userFolioSelectedCopy?.[item.id]?.downloadFile)

    return {
      seeFile: !seeFile && rowFiltered?.length,
      downloadFile: !downloadFile && rowFiltered?.length
    }
  }, [userFolioSelected])

  const selectOrUnSelectAll = (payload?: { name: string; value: boolean }) => {
    const { name, value } = payload || {};
    let userFolioSelectedCopy = removeAllReference(userFolioSelected)

    if (name == 'seeFile') {
      const existSomeConfig = rowFiltered?.some((item) => !!userFolioSelected[item.id]?.downloadFile && !value)
      if (existSomeConfig) {
        setOpenModal((prev) => ({
          ...prev,
          open: true,
          title: t('filesManager.modal.titles.deleteSettings'),
          description: t('filesManager.modal.description.deleteSettings'),
          confirm: () => {
            rowFiltered.forEach((item) => {
              userFolioSelectedCopy[item.id] = {
                ...userFolioSelectedCopy[item.id],
                downloadFile: value,
                [name]: false
              };
            });
            setUserFolioSelected(userFolioSelectedCopy)
            closeModal()
          }
        }))
        return
      }
    }
    if (name == 'seeFile') {
      rowFiltered.forEach(row => {
        userFolioSelectedCopy[row.id] = { ...userFolioSelectedCopy[row.id], seeFile: !!payload?.value }
      })
    }
    if (name == 'downloadFile' && !!headersChecks.seeFile) {
      rowFiltered.forEach(row => {
        userFolioSelectedCopy[row.id] = { ...userFolioSelectedCopy[row.id], downloadFile: !!payload?.value }
      })
    }

    setUserFolioSelected(userFolioSelectedCopy)
  }

  const deletedUsersSelecteds = (payload?: { id: string }) => {
    setOpenModal((prev) => ({
      ...prev,
      open: true,
      title: t('filesManager.modal.titles.deleteSettingsPermission', { count: payload?.id ? 1 : 0 }),
      description: t('filesManager.modal.description.deletePermissionDescription'),
      confirm: () => {
        const selectUserCopy = removeAllReference(userSelected)
        const userFolioSelectedCopy = removeAllReference(userFolioSelected)

        if (payload?.id) {
          setRow(prev => prev.filter(item => item.id != payload.id))
          delete selectUserCopy[payload.id]
          delete userFolioSelectedCopy[payload.id]
          setUserSelected(selectUserCopy)
          setUserFolioSelected(userFolioSelectedCopy)
          setDeletedSelected(prev => prev.filter(item => item != payload.id))
          closeModal()
          return
        }
        setRow(prev => prev.filter(item => !deleteSelected.includes(item.id)))
        deleteSelected.forEach(item => {
          delete selectUserCopy[item]
          delete userFolioSelectedCopy[item]
        })
        setUserFolioSelected(userFolioSelectedCopy)
        setUserSelected(selectUserCopy)
        setDeletedSelected([])
        closeModal()
      }
    }))

  }

  const column = [
    {
      id: 'name',
      label: t('general.tags.name'),
      sortable: true,
    },
    {
      id: 'roleName',
      label: t('general.tags.role'),
      sortable: true,
    },
    {
      id: 'areaName',
      label: t('general.tags.area'),
      sortable: true,
      renderCell: (params: any) => {
        const areaArray = params.current ? params.current.split(',').map((item: string) => item.trim()) : undefined;
        const firstTwoAreas = areaArray?.slice(0, 2);
        const remainingAreas = areaArray?.slice(2);
        return (
          <Box /* sx={styles.containerStatus} */>
            <Typography sx={styles.areaTitle}>
              {firstTwoAreas?.join(', ')}
              {remainingAreas?.length > 0 && (
                <Tooltip
                  title={
                    <List>
                      {remainingAreas.map((item: string, index: number) => (
                        <ListItem key={index} style={{ padding: 0 }}>
                          {item}
                        </ListItem>
                      ))}
                    </List>
                  }
                >
                  <Icon sx={styles.viewMore}>{icons('add')}</Icon>
                </Tooltip>
              )}
              {!areaArray && 'N/A'}
            </Typography>
          </Box>
        )
      },
    },
    {
      id: 'departmentName',
      label: t('general.tags.department'),
      sortable: true,
      renderCell: (params: any) => {
        const departmentArray = params.current ? params.current.split(',').map((item: string) => item.trim()) : undefined;
        const firstTwoDepartments = departmentArray?.slice(0, 2);
        const remainingDepartments = departmentArray?.slice(2);
        return (
          <Box /* sx={styles.containerStatus} */>
            <Typography sx={styles.areaTitle}>
              {firstTwoDepartments?.join(', ')}
              {remainingDepartments?.length > 0 && (
                <Tooltip
                  title={
                    <List>
                      {remainingDepartments.map((item: string, index: number) => (
                        <ListItem key={index} style={{ padding: 0 }}>
                          {item}
                        </ListItem>
                      ))}
                    </List>
                  }
                >
                  <Icon sx={styles.viewMore}>{icons('add')}</Icon>
                </Tooltip>
              )}
              {!departmentArray && 'N/A'}
            </Typography>
          </Box>
        )
      },
    },
    {
      id: 'userTypeDescription',
      label: t('general.tags.userType'),
    },
    {
      id: 'seeFile',
      label: t('general.tags.seeFile'),
      minWidth: 100,
      headerCell: {
        '&.header-cell.header-cell': {
          whiteSpace: 'normal'
        }
      },
      column: () => {
        return (
          <Box sx={styles.all}>
            <Checkbox
              className='remove-m'
              name="delete"
              checked={!!headersChecks.seeFile}
              onChange={(_, check) => {
                selectOrUnSelectAll({ name: 'seeFile', value: check })
              }}
              sx={{ m: 1 }}
            />

            <Typography sx={styles.checkLabel}>
              {t('general.tags.seeFile')}
            </Typography>
          </Box>
        )
      },
      renderCell: (params: any) => {
        return (
          <Box sx={styles.action}>
            <Checkbox
              name="seeFile"
              /* disabled={!!userFolioSelected?.[params?.row?.id]?.status} */
              checked={!!userFolioSelected?.[params?.row?.id]?.seeFile}
              onChange={(_, check) => {
                /* if (!userFolioSelected?.[params?.row?.id]?.status) { */
                handleSelect({ id: params?.row?.id, value: check, name: 'seeFile' })
                /* } */
              }}
              sx={{ m: 1 }}
            />
          </Box>
        )
      },
    },
    {
      id: 'downloadFile',
      label: t('general.tags.downloadFile'),
      minWidth: 100,
      headerCell: {
        '&.header-cell.header-cell': {
          whiteSpace: 'normal'
        }
      },
      column: () => {
        return (
          <Box sx={styles.all}>
            <Checkbox
              className='remove-m'
              name="delete"
              checked={!!headersChecks.downloadFile}
              onChange={(_, check) => {
                selectOrUnSelectAll({ name: 'downloadFile', value: check })
              }}
              sx={{ m: 1 }}
            />

            <Typography sx={styles.checkLabel}>
              {t('general.tags.downloadFile')}
            </Typography>
          </Box>
        )
      },
      renderCell: (params: any) => {
        return (
          <Box sx={styles.action}>
            <Checkbox
              name="downloadFile"
              disabled={!userFolioSelected?.[params?.row?.id]?.seeFile}
              checked={!!userFolioSelected?.[params?.row?.id]?.downloadFile}
              onChange={(_, check) => {
                /* if (!userFolioSelected?.[params?.row?.id]?.status) { */
                handleSelect({ id: params?.row?.id, value: check, name: 'downloadFile' })
                /* } */
              }}
              sx={{ m: 1 }}
            />
          </Box>
        )
      },
    }
  ]

  useEffect(() => {
    if (props.tab === TabsChildren.PERMISSIONS) {
      getUsersThatCanManageFolios()
    }

  }, [props?.tab, userSelected])


  return {
    userSelected,
    rowFiltered,
    row,
    column,
    openModal,
    userFolioSelected,
    deleteSelected,
    deletedUsersSelecteds,
    setDeletedSelected,
    setUserSelected,
    closeModal,
    setAllSettingsFolioUser
  }
}

export { useTables }
